import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { PropType, computed } from 'vue';
import { IAccount } from '@/lib';
import { BaseButton } from '@/lib/components/Button';
import AccountListItem from './AccountListItem.vue';
import { i18n } from '@/i18n/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountList',
  props: {
  items: {
    type: Array as PropType<IAccount[]>,
    default: () => []
  },
  buttonText: {
    type: String,
    default() {
      return i18n.global.t('platform.patient.add-account') as string;
    }
  },
  disabled: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  showAddButton: {
    type: Boolean,
    default: true
  },
  showEditButtons: {
    type: Boolean,
    default: true
  },
  showDeleteButtons: {
    type: Boolean,
    default: true
  }
},
  emits: ["edit", "delete", "add-account"],
  setup(__props) {

const props = __props;


const displayedItems = computed<IAccount[]>(() => props.items.filter((a) => a.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedItems.value, (item, index) => {
      return (_openBlock(), _createBlock(AccountListItem, {
        id: item.value,
        key: item.typeId,
        label: item.label,
        "logo-uri": item.logoUri,
        "last-connection": item.lastConnection,
        "data-cy": `account-${item.label}`,
        readonly: __props.readonly,
        class: _normalizeClass(["border-b border-gray-300 account-item", index === 0 ? 'border-t' : '']),
        "show-edit-button": __props.showEditButtons,
        "show-delete-button": __props.showDeleteButtons,
        onEdit: ($event: any) => (_ctx.$emit('edit', item)),
        onDelete: ($event: any) => (_ctx.$emit('delete', item))
      }, null, 8, ["id", "label", "logo-uri", "last-connection", "data-cy", "readonly", "class", "show-edit-button", "show-delete-button", "onEdit", "onDelete"]))
    }), 128)),
    (__props.showAddButton && !__props.readonly)
      ? (_openBlock(), _createBlock(_unref(BaseButton), {
          key: 0,
          "data-dusk": "add-btn",
          color: "ghost",
          "left-icon": "add",
          disabled: __props.disabled,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('add-account')), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.buttonText), 1)
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})